module.exports = __webpack_public_path__ + "img/C05TechPraesidium_ua.582490e8.webp";